import Clarity from '@microsoft/clarity'

const projectId = import.meta.env.VENTAS_CLARITY_PROJECT_ID
if (projectId) Clarity.init(projectId)
